import { render } from "./Kartenaddition.vue?vue&type=template&id=6f43cf3a&scoped=true"
import script from "./Kartenaddition.vue?vue&type=script&lang=js"
export * from "./Kartenaddition.vue?vue&type=script&lang=js"

import "./Kartenaddition.vue?vue&type=style&index=0&id=6f43cf3a&scoped=true&lang=css"

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f43cf3a"]])

export default __exports__